import { CHECK_CUSTOM_ACCOUNT, CHECK_SUB_ACCOUNT, LAYOUT_SETTINGS, PUBLIC_API_URL, SITE_META } from '../../constants/api';
import { ApiInterceptionFetch } from './api.interceptor';

class LayoutService {
    static index = async () => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${LAYOUT_SETTINGS}`,
                {
                    method: 'GET',
                },
                false,
            );

            if (!response.ok) {
                const errorData = await response.json();

                throw new Error(errorData.message || 'Failed to delete');
            }

            const data = await response.json();

            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static siteMeta = async (domain, domainType) => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${SITE_META}`,
                {
                    method: 'GET',
                    headers: {
                        'X-Domain-Id': domain,
                        'X-Domain-Type': domainType,
                    },
                },
                false,
            );

            if (!response.ok) {
                const errorData = await response.json();

                throw new Error(errorData.message || 'Failed to delete');
            }

            const data = await response.json();

            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static checkSubAccount = async (domain) => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${CHECK_SUB_ACCOUNT}`,
                {
                    method: 'POST',
                    body: JSON.stringify({ domain }),
                },
                false,
            );

            if (!response.ok) {
                const errorData = await response.json();

                throw new Error(errorData.message || 'Failed to delete');
            }

            const data = await response.json();

            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static checkCustomAccount = async (domain) => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${CHECK_CUSTOM_ACCOUNT}`,
                {
                    method: 'POST',
                    body: JSON.stringify({ domain }),
                },
                false,
            );

            if (!response.ok) {
                const errorData = await response.json();

                throw new Error(errorData.message || 'Failed to delete');
            }

            const data = await response.json();

            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };
}
export default LayoutService;
